import {Fragment, h} from 'preact';
import {Card, CF} from "../_common/layout";
import {UploadFile} from "../_common/forms/components/components";
import {t} from "../_i18n";
import {useEffect, useState} from "preact/hooks";
import {connect, useDispatch} from "react-redux";
import {AppPage} from "../_common/components/app-page";
import {useHistory} from 'react-router';
import ButtonSpinner from "../_common/components/buttons/buttonSpinner/buttonSpinner";
import Badge from "../_common/components/Badge";
import {
    HOMOLOGATION_STATUS_PENDING,
    HOMOLOGATION_STATUS_REVIEW,
    HOMOLOGATION_STATUS_VALIDATED,
    HOMOLOGATION_STATUS_VALIDATION,
} from "../constants";
import {downloadNeeDocument, uploadDocument} from "../_rx/student/actions";
import {downloadHomologation, getHomologationStatus} from "../_rx/homologation/actions";
import {toastService} from "../_services/toast-service";


const statusBadgeTextDic = {
    [HOMOLOGATION_STATUS_PENDING]: t('Pendiente'),
    [HOMOLOGATION_STATUS_VALIDATION]: t('Validando'),
    [HOMOLOGATION_STATUS_REVIEW]: t('Revisar'),
    [HOMOLOGATION_STATUS_VALIDATED]: t('Validado'),
};
const statusBadgeClassDic = {
    [HOMOLOGATION_STATUS_PENDING]: 'badge-warning',
    [HOMOLOGATION_STATUS_VALIDATION]: 'badge-warning',
    [HOMOLOGATION_STATUS_REVIEW]: 'badge-danger',
    [HOMOLOGATION_STATUS_VALIDATED]: 'badge-success translucent',
};

const BadgeComponent = ({status, extraClass})=><Badge className={`t-upper width-fit-content badge font-small full-width flex-align-self-end ${statusBadgeClassDic[status] || 'd-none'}`}>{t(statusBadgeTextDic[status])}</Badge>

function Homologation({ studentId }) {

    const [file, setFile] = useState(null);
    const [fileURL, setFileURL] = useState('#');
    const [loading, setLoading] = useState(false);
    const [initialLoading, setInitialLoading] = useState(true);
    const homologationDocument = 103;
    const dispatch = useDispatch();

    const fetchHomologation = async () => {
        const result = await dispatch(getHomologationStatus(studentId));
        const doc = result?.document_id && result?.document_name
            ? {
                name: result.document_name,
                source: 'server',
                id: result.document_id,
                status: result.status
            }
            : null;
        setFile(doc);
        setInitialLoading(false);
    };

    useEffect(() => {
        fetchHomologation().then();
    }, []);

    const handleUploadFile =  (event) => {
        let uploadFile = event.target.files[0];
        setFile({
            name: uploadFile.name,
            url: URL.createObjectURL(uploadFile),
            rawFile: uploadFile,
            source: 'local'
        });
    }

    const handleRemoveFile = () => {
        setFile(null);
    }

    const handleSubmitFile = async () => {
        if (!file?.rawFile) return;
        setLoading(true);
        const uploadFn = uploadDocument(studentId, file.rawFile, homologationDocument);
        await uploadFn();
        fetchHomologation().then();
        handleRemoveFile();
        setLoading(false);
        setInitialLoading(true);
    }

    const handleServerFileClick = async () => {
        try {
            await downloadHomologation(studentId, file.id, file.name);
        } catch (e) {
            toastService.showToast({ message: e.message, type: 'danger' });
        }
    };



    return (
        <CF className="max-width-980 m-x2-top">
            <div dangerouslySetInnerHTML={{__html: t("homologation_text")}}/>
            <div className="m-top">
                <p className="font-bold m-bottom"> {t("Homologacion")}: </p>
                    {initialLoading ? (
                        <div className="m-top">{t("Cargando información...")}</div>
                    ) : !file ? (
                        <div className='p-top'>
                            <UploadFile
                                classNameButton='btn btn-ghost m-top m-bottom t-upper'
                                accept='application/pdf,.docx,.doc,.odt'
                                onChange={handleUploadFile}
                            >
                                {t('Subir archivo')}
                            </UploadFile>
                            <span className='m-top font-color-879CA1'>{t('transfer_expedient_doc_types')}</span>
                        </div>
                    ) : (
                        <Card>
                            <div className='m-bottom d-flex flex-column sm-no-flex-column'>
                                {file.source === 'server' ? (
                                    <div className="d-flex full-width">
                                        <a className='m-r font-color-149BAB m-bottom sm-no-m-bottom t-underline cursor-pointer'
                                           onClick={handleServerFileClick}
                                        >
                                            {file.name}
                                        </a>
                                        {file.status !== HOMOLOGATION_STATUS_VALIDATED  &&
                                            <span className='cursor-pointer font-color-soft-gray t-underline' onClick={handleRemoveFile}>
                                                {t('Quitar archivo')}
                                            </span>
                                        }
                                    </div>
                                ) : (
                                    <div className="d-flex full-width">
                                        <a className='m-r font-color-149BAB m-bottom sm-no-m-bottom'
                                           href={file.url}
                                           download={file.name}
                                        >
                                            {file.name}
                                        </a>
                                        <span className='cursor-pointer font-color-soft-gray t-underline'
                                              onClick={handleRemoveFile}>
                                            {t('Quitar archivo')}
                                        </span>
                                    </div>
                                )}
                                {file && file.source === 'server' && <div className="d-flex flex-align-self-end flex-right"><BadgeComponent status={file.status}/></div>}
                            </div>
                        </Card>
                    )}
            </div>
            <div className='m-x2-top t-upper m-x2-bottom'>
                <ButtonSpinner showSpinner={loading} disabled={!file?.rawFile}
                               onClick={handleSubmitFile}>
                    {t('Enviar solicitud')}
                </ButtonSpinner>
            </div>
        </CF>
    )
}

Homologation = connect(
    ({auth}) => ({
        studentId: auth.loggedUser.id,
    }), {})(Homologation);

export default () => {
    const history = useHistory();
    return (
        <AppPage
            name="homologacion"
            title={t('Homologacion')}
            back={history.goBack}
            class="max-width-980">
            <Homologation/>
        </AppPage>
    );
}
